import { render, staticRenderFns } from "./CompanyTeam.vue?vue&type=template&id=5a98e5b8&"
import script from "./CompanyTeam.vue?vue&type=script&lang=js&"
export * from "./CompanyTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports